import { Filter, Log } from "../MyHelpers";

export type ResourceLoadedCallback = () => void;
export type ResourceLoadErrorCallback = () => void;

export abstract class Resource
{
	public loadRetryCount: number = 0;

	name: string = "";
	path: string = "";

	altPaths: string[] = [];

	required: boolean = true;
	processed: boolean = false;
	loaded: boolean = false;
	abstract Load(preventChache: boolean): void;
	public Reload(preventChache: boolean): void
	{
		this.processed = false;
		this.loaded = false;
	}

	abstract get Name(): string;
	abstract get Type(): string;
	

	public constructor(path: string, name: string = null, required: boolean = true) {
		if (name == null) {
			name = path;
		}

		this.name = name;
		this.path = path;
		this.required = required;
	}


	// callbacks
	protected onLoadedCallbacks: ResourceLoadedCallback[] = [];
	public AddOnLoadedCallback(callback: ResourceLoadedCallback) {
		this.onLoadedCallbacks.push(callback);
	}

	protected Loaded() {

		if (this.processed)
		{
			// already processed
			throw `Resource ${this.name} already processed, but called Loaded() again`;
			return;
		}

		this.loaded = true;
		this.processed = true;

		for (let i = 0; i < this.onLoadedCallbacks.length; i++) {
			Log.Debug(this.name, `Calling Loaded callback ${i}/${this.onLoadedCallbacks.length}`);
			this.onLoadedCallbacks[i]();
		}
	}

	protected onLoadErrorCallbacks: ResourceLoadErrorCallback[] = [];
	public AddOnLoadErrorCallback(callback: ResourceLoadErrorCallback) {
		this.onLoadErrorCallbacks.push(callback);
	}

	protected LoadError() {

		// if (this.processed)
		// {
		// 	// already processed
		// 	throw `Resource ${this.name} already processed, but called LoadError() again`;
		// 	return;
		// }
		this.processed = true;
		this.loaded = false;

		for (let i = 0; i < this.onLoadErrorCallbacks.length; i++) {
			Log.Debug(this.name, `Calling LoadError callback ${i}/${this.onLoadErrorCallbacks.length}`);
			this.onLoadErrorCallbacks[i]();
		}
	}

	public AddAlternativeResource(resource: Resource): void
	{
		this.altPaths = [...this.altPaths, ...resource.GetPaths()].filter(Filter.UniqueItem);
	}

	public GetPaths(): string[]
	{
		return [this.path, ...this.altPaths].filter(Filter.UniqueItem);
	}
}